var exports = {
  "k": "x7f9a0e16--09f8c5--container",
  "x": "x7f9a0e16--09f8c5--button",
};

module.exports = exports;
